import React, { FC, ReactNode } from 'react';
import { classNames } from '../utils';

import './PageHeader.scss';

interface Props {
  readonly children?: ReactNode;
  readonly className?: string;
}

export const PageHeader: FC<Props> = ({ children, className }: Props) => {
  return (
    <div className={classNames({}, 'page-header', className ?? '')}>
      <h1>{children}</h1>
    </div>
  );
};
